import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FunctionsIcon from "@mui/icons-material/Functions";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ScienceIcon from "@mui/icons-material/Science";

/**
 * category: "Math" | "Reading" | "English" | "Science"
 */
const getCategoryIcon = (category) => {
  switch (category) {
    case "Math":
      return <FunctionsIcon />;
    case "Reading":
    case "English":
      return <MenuBookIcon />;
    case "Science":
      return <ScienceIcon />;
    default:
      return <AssignmentIcon />;
  }
};

const TutorAssignmentCard = ({ a, onView, onShare }) => {
  const [starred, setStarred] = useState(a.starred);

  return (
    <Card
      sx={{
        minHeight: 115,
        p: 2.25,
        borderRadius: 3,
        backgroundColor: "rgba(255,255,255,0.95)",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* TOP ROW */}
      <Box display="flex" alignItems="flex-start" justifyContent="space-between">
        <Box display="flex" alignItems="flex-start">
          <Box
            sx={{
              mr: 1,
              mt: "2px", // nudges icon to align with first line
              color: "text.secondary",
            }}
          >
            {getCategoryIcon(a.category)}
          </Box>

          {/* TITLE (1–2 lines, fixed vertical space) */}
          <Box
            sx={{
              minHeight: "2.5em",          // space for up to 2 lines
              display: "flex",
              alignItems: "center",        // centers single-line vertically
            }}
          >
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{
                mt: -1.25,
                lineHeight: 1.25,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {a.title}
            </Typography>
          </Box>
        </Box>

        <IconButton
          size="small"
          onClick={() => setStarred((prev) => !prev)}
          sx={{
            color: starred ? "#f5c518" : "text.secondary",
            mt: "-2px",
          }}
        >
          {starred ? <StarIcon /> : <StarBorderIcon />}
        </IconButton>
      </Box>

      {/* INFO ROW */}
      <Typography variant="body2" mt={1.25}>
        {a.problemCount} Problems •{" "}
        {a.type === "diagnostic" ? "All" : a.assignedCount} Students
      </Typography>

      <Box sx={{ flexGrow: 1 }} />

      {/* ACTION BUTTONS */}
      <Box display="flex" gap={1} mt={1.5}>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => onView?.(a)}
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: 10 }}
        >
          View
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={() => onShare?.(a)}
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: 10 }}
        >
          Share
        </Button>
      </Box>
    </Card>
  );
};

export default TutorAssignmentCard;
